import React from 'react';
import {I18nUtils} from "../../../i18n/I18nUtils";
import Loadable from "react-loading-overlay";
import PropTypes from "prop-types";

export default class LoadingView extends React.Component {
    render(){
        const {loading, children} = this.props;

        return (
            <Loadable
                active={loading}
                spinner
                text={I18nUtils.tr('TR_CARGANDO')}
                background={'rgba(255,255,255,.9)'}
                color={'rgb(0,0,0)'}
                zIndex={10}
            >
                {children}
            </Loadable>
        )
    }
}

LoadingView.propTypes = {
    loading: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/app/shared/components/LoadingView.js